export const MESSAGES_ROUTES = {
  __ROOT__: '/messages',
}